import { io, Socket } from "socket.io-client";
import { environment } from "environment/environment";

let socket: Socket | undefined;
let registeredUserId: string | undefined;

export const getSocket = (): Socket => {
  if (!socket) {
    socket = io(environment.api_url, {
      autoConnect: false,
      transports: ["websocket", "polling"],
    });
  }

  return socket;
};

export const connectSocket = (userId?: string): Socket => {
  const activeSocket = getSocket();

  if (!activeSocket.connected) {
    activeSocket.connect();
  }

  if (userId && registeredUserId !== userId) {
    activeSocket.emit("register", userId);
    registeredUserId = userId;
  }

  return activeSocket;
};

export const disconnectSocket = (): void => {
  if (socket?.connected) {
    socket.disconnect();
  }
  registeredUserId = undefined;
};
